<template>
  <div>
    <div class="schedule-button-container">
      <!-- <p v-if="userName" class="greeting-text">{{ userName }}様、こんにちは！</p> -->
      <p class="greeting-text">
        SukiSukiらいぶすてーしょんの資料をご覧いただきありがとうございます。
      </p>
      <p class="greeting-text">
        もし少しでもご興味をお持ちいただけましたら、<br />ぜひ一度、オンラインでご説明できれば嬉しいです。
      </p>
      <v-btn
        class="mt-5"
        height="35"
        width="230"
        rounded="pill"
        @click="showScheduleForm = true"
        color="rgb(237, 121, 149)"
      >
        <a class="login">オンライン説明を予約する</a>
      </v-btn>
    </div>

    <v-dialog v-model="showScheduleForm" max-width="800" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">
          日程を選択
          <v-btn icon @click="showScheduleForm = false" class="close-button">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <!-- Google Calendar Appointment Scheduling begin -->
          <iframe
            src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2_Zw7-UAHspRkCfcxauqAX4Ak8ce-qKcWAKUsACo9-Kdd8vUWTuJ8D8WxM1jR4cDS04oflYne3?gv=true"
            style="border: 0"
            width="100%"
            height="600"
            frameborder="0"
          ></iframe>
          <!-- end Google Calendar Appointment Scheduling -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="isPdfLoading" class="loading">資料を読み込み中...</div>
    <div v-if="loadError" class="error">
      {{ errorMessage }}
      <button @click="reloadPage" class="reload-button">ページを更新</button>
    </div>
    <iframe
      :src="pdfViewerUrl"
      width="100%"
      height="900px"
      style="border: none"
      @load="handleIframeLoad"
      @error="handleIframeError"
    ></iframe>
    <!-- フォールバックとしてPDFダウンロードリンク -->
    <p v-if="!isPdfSupported" style="margin-top: 30px">
      SukiSukiらいぶすてーしょんの資料は
      <a :href="pdfUrl" target="_blank" rel="noopener noreferrer">こちら</a
      >からダウンロードしてください。
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { getFunctions, httpsCallable } from "firebase/functions";

// ユーザー名を管理
const userName = ref("");

// Tawk.toの初期化
const initializeTawkTo = () => {
  // 既存のTawk.toスクリプトを削除
  const existingScript = document.querySelector('script[src*="tawk.to"]');
  if (existingScript) {
    existingScript.remove();
  }

  // Tawk.toの設定を初期化
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  // ユーザー名が存在する場合のみ設定
  if (userName.value) {
    window.Tawk_API.onLoad = function () {
      // 遅延時間を3秒に設定
      setTimeout(() => {
        window.Tawk_API.setAttributes(
          {
            name: userName.value,
          },
          function (error) {
            if (error) {
              console.error("Tawk.to: ユーザー名の設定に失敗しました", error);
              // 失敗した場合は3秒後に再試行
              setTimeout(() => {
                window.Tawk_API.setAttributes(
                  {
                    name: userName.value,
                  },
                  function (retryError) {
                    if (retryError) {
                      console.error("Tawk.to: 再試行も失敗しました", retryError);
                    } else {
                      console.log(
                        "Tawk.to: 再試行でユーザー名が正常に設定されました",
                        userName.value
                      );
                    }
                  }
                );
              }, 3000);
            } else {
              console.log("Tawk.to: ユーザー名が正常に設定されました", userName.value);
            }
          }
        );
      }, 3000);
    };
  } else {
    // 名前が存在しない場合はonLoadを設定しない
    window.Tawk_API.onLoad = function () {
      console.log("Tawk.to: 名前が設定されていないため、デフォルト設定で初期化します");
    };
  }

  const s1 = document.createElement("script");
  const s0 = document.getElementsByTagName("script")[0];
  s1.async = true;
  s1.src = "https://embed.tawk.to/67f95c851284d1190717a86b/1ioj7p7c0";
  s1.charset = "UTF-8";
  s1.setAttribute("crossorigin", "*");
  s0.parentNode.insertBefore(s1, s0);
};

// PDFの読み込み状態を管理
const isPdfLoading = ref(true);
const loadError = ref(false);
const errorMessage = ref("");

// URLからクエリパラメータを取得する関数
const getQueryParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

// Firebase Functionsを呼び出す関数
const result = ref(null);
const callFunction = async (documentId) => {
  try {
    const functions = getFunctions(undefined, "asia-northeast1");
    const getDocument = httpsCallable(functions, "sendToEngageTreca");

    const response = await getDocument({ id: documentId });

    // 結果から名前を取得
    if (response.data && response.data.name) {
      userName.value = response.data.name;
      // 名前が取得された後にTawk.toを再初期化
      initializeTawkTo();
    } else {
      userName.value = null;
      // 名前が取得できなかった場合でもTawk.toを初期化
      initializeTawkTo();
      console.warn("名前の取得に失敗しました。デフォルトの設定でTawk.toを初期化します。");
    }

    console.log("Firebase Functions レスポンス:", response.data);
  } catch (err) {
    console.error("Firebase Functions エラー:", err);
    result.value = { error: err.message };
    userName.value = null;
    // エラー時もTawk.toを初期化
    initializeTawkTo();
    console.warn("エラーが発生しましたが、Tawk.toはデフォルトの設定で初期化します。");
  }
};

// URLからIDを取得
const documentId = getQueryParam("id");

// PDFファイルのURL
const pdfUrl = ref(
  "https://storage.googleapis.com/rf-prd-sukisuki-ls.appspot.com/live_station_images_common/SukiSuki%E3%82%89%E3%81%84%E3%81%B5%E3%82%99%E3%81%99%E3%81%A6%E3%83%BC%E3%81%97%E3%82%87%E3%82%93%E3%83%9B%E3%82%99%E3%82%A4%E3%82%B9%E3%83%88%E3%83%AC%E3%82%AB.pdf"
);

// PDFビューアー用のURL
const pdfViewerUrl = ref(
  `https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl.value)}&embedded=true`
);

// iframeの読み込み完了を処理
const handleIframeLoad = () => {
  isPdfLoading.value = false;
  loadError.value = false;
  errorMessage.value = "";
};

// iframeの読み込みエラーを処理
const handleIframeError = () => {
  isPdfLoading.value = false;
  loadError.value = true;
  errorMessage.value = "資料の読み込みに失敗しました。ページを更新してください。";
  console.error("PDFの読み込みに失敗しました");
};

// タイムアウト処理
let timeoutId;
const startTimeout = () => {
  timeoutId = setTimeout(() => {
    if (isPdfLoading.value) {
      isPdfLoading.value = false;
      loadError.value = true;
      errorMessage.value = "資料の読み込みに失敗しました。ページを更新してください。";
      console.error("PDFの読み込みがタイムアウトしました");
    }
  }, 30000); // 30秒
};

// ページを更新するメソッド
const reloadPage = () => {
  window.location.reload();
};

// コンポーネントのマウント時に実行
onMounted(() => {
  startTimeout();
  initializeTawkTo();
  // IDが存在する場合のみ関数を実行
  if (documentId) {
    callFunction(documentId);
  } else {
    console.log("URLにIDが指定されていないため、処理をスキップします");
  }
});

// コンポーネントのアンマウント時に実行
onUnmounted(() => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
});

// ブラウザがネイティブのPDF表示をサポートしているか確認
const isPdfSupported = ref(
  (() => {
    const canvas = document.createElement("canvas");
    return !!(canvas.getContext && canvas.getContext("2d"));
  })()
);

// 予約フォームの表示状態を管理
const showScheduleForm = ref(false);
</script>

<style scoped>
.loading {
  text-align: center;
  padding: 20px;
  font-size: 1.2em;
  color: #666;
}

.error {
  text-align: center;
  padding: 20px;
  font-size: 1.2em;
  color: #ff4444;
  background-color: #fff5f5;
  border-radius: 4px;
  margin: 10px 0;
}

.reload-button {
  display: block;
  margin: 10px auto;
  padding: 8px 16px;
  background-color: #f0acc4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1em;
}

.reload-button:hover {
  background-color: #e89db3;
}

.schedule-button-container {
  text-align: center;
  padding: 20px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.greeting-text {
  margin: 10px 0;
  line-height: 1.6;
  color: #333;
}

.login {
  color: rgb(255 255 255);
  font-size: 14px;
}

.close-button {
  position: absolute;
  right: 8px;
  top: 8px;
}
</style>
